import {
  FAILED_SET_CUSTOMER_INFO,
  FAILED_SET_CUSTOMER_PACKAGE_INFO,
  GET_NOTIFICATIONS_LIST,
  SET_ACTIVE_SERVICES,
  SET_AVAILABLE_PROGRAMS,
  SET_BILLS_DATA,
  SET_CUSTOMER_INFO,
  SET_CUSTOMER_PACKAGE_INFO,
  SET_INSTALLMENTS,
  SET_PACKAGE_DETAILS,
  SET_PROFILE_PICTURE,
  SET_ACCESS_PAGE_LIST,
  SET_PROFILE_DATA,
  SET_LATEST_PAYMENT_FOR_OTHERS,
  SET_REFLECT_INFO,
} from './actionsTypes'

const REFLECT_INFO_STORAGE_KEY = 'hesabi_reflect_info'

const REFLECT_INFO_LEGACY_KEY = 'hesabi_reflect_first_iban'

const getInitialReflectInfo = () => {
  try {
    let stored = localStorage.getItem(REFLECT_INFO_STORAGE_KEY)
    if (!stored) {
      const legacy = localStorage.getItem(REFLECT_INFO_LEGACY_KEY)
      if (legacy) return { firstIbanDisplay: legacy, formData: null }
      return { firstIbanDisplay: null, formData: null }
    }
    // New format: JSON { firstIbanDisplay, formData }
    if (stored.startsWith('{')) {
      const parsed = JSON.parse(stored)
      return {
        firstIbanDisplay: parsed.firstIbanDisplay || null,
        formData: parsed.formData || null,
      }
    }
    return { firstIbanDisplay: stored, formData: null }
  } catch {
    return { firstIbanDisplay: null, formData: null }
  }
}

const initialState = {
  customerInfo: {},
  currentPackageInfo: [],
  availablePrograms: [],
  packageDetails: {},
  billsData: {},
  installments: {},
  activeServiceInfo: {},
  errorMsg: null,
  notifications: {},
  profilePicture: { isLoading: false, src: null },
  quickAccessPageList: {},
  profileData: {},
  latestPaymentForOthers: {},
  reflectInfo: getInitialReflectInfo(),
}

const CustomerInfoData = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CUSTOMER_INFO:
      return {
        ...state,
        customerInfo: payload,
        errorMsg: null,
      }
    case SET_CUSTOMER_PACKAGE_INFO:
      return {
        ...state,
        currentPackageInfo: payload,
        errorMsg: null,
      }
    case FAILED_SET_CUSTOMER_PACKAGE_INFO:
      return {
        ...state,
        errorMsg: payload,
      }
    case SET_AVAILABLE_PROGRAMS:
      return {
        ...state,
        availablePrograms: payload,
      }
    case SET_PACKAGE_DETAILS:
      return {
        ...state,
        packageDetails: payload,
      }
    case SET_BILLS_DATA:
      return {
        ...state,
        billsData: payload,
      }
    case SET_INSTALLMENTS:
      return {
        ...state,
        installments: payload,
      }
    case SET_ACTIVE_SERVICES:
      return {
        ...state,
        activeServiceInfo: payload,
      }
    case GET_NOTIFICATIONS_LIST:
      return {
        ...state,
        notifications: payload,
      }
    case FAILED_SET_CUSTOMER_INFO:
      return {
        ...state,
        errorMsg: payload,
      }
    case SET_PROFILE_PICTURE:
      return {
        ...state,
        profilePicture: payload,
      }
    case SET_ACCESS_PAGE_LIST:
      return {
        ...state,
        quickAccessPageList: payload,
      }
    case SET_PROFILE_DATA:
      return {
        ...state,
        profileData: payload,
      }
    case SET_LATEST_PAYMENT_FOR_OTHERS:
      return {
        ...state,
        latestPaymentForOthers: payload,
      }
    case SET_REFLECT_INFO:
      return {
        ...state,
        reflectInfo: payload,
      }
    default:
      return state
  }
}

export default CustomerInfoData
